import useSWR from 'swr';

import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

import { SCHEDULER_MASTER_POSTS } from '@/lib/routes/apiEndpoints';

export const useMasterPosts = ({ masterIds }: { masterIds?: number[] }) => {
    // Only create a key if we have valid masterIds to fetch
    const key =
        masterIds && masterIds.length > 0 ? `master-posts-${masterIds.toSorted().join(',')}` : null;

    const { data, isLoading, error } = useSWR(
        key, // SWR won't call the fetcher if key is null
        async () => {
            // Fetch all master posts in parallel
            const promises = masterIds.map((masterId) => {
                if (!masterId) return null;
                return get(injectEndpointUrlParams(SCHEDULER_MASTER_POSTS, { masterId }))
                    .then((res) => res.data?.master)
                    .catch(() => null); // Return null for failed requests
            });

            const results = await Promise.all(promises);
            return results.filter(Boolean); // Filter out null/undefined results
        }
    );

    return {
        masterPosts: data ?? [],
        isLoading,
        hasError: !!error
    };
};
